"use client";

import { c as _c } from "react/compiler-runtime";
import type { DropInteractionParams } from "@/components/waves/drops/Drop";
import Drop, { DropLocation } from "@/components/waves/drops/Drop";
import type { ApiDrop } from "@/generated/models/ApiDrop";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { convertApiDropToExtendedDrop } from "@/helpers/waves/drop.helpers";
import type { ActiveDropState } from "@/types/dropInteractionTypes";
interface NotificationDropProps {
  readonly drop: ApiDrop;
  readonly activeDrop: ActiveDropState | null;
  readonly onReply: (param: DropInteractionParams) => void;
  readonly onQuote: (param: DropInteractionParams) => void;
  readonly onReplyClick: (serialNo: number) => void;
  readonly onQuoteClick: (quote: ApiDrop) => void;
  readonly onDropContentClick?: ((drop: ExtendedDrop) => void) | undefined;
}
export default function NotificationDrop(t0) {
  const $ = _c(10);
  const {
    drop,
    activeDrop,
    onReply,
    onQuote,
    onReplyClick,
    onQuoteClick,
    onDropContentClick
  } = t0;
  let t1;
  if ($[0] !== drop) {
    t1 = convertApiDropToExtendedDrop(drop);
    $[0] = drop;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const extendedDrop = t1;
  let t2;
  if ($[2] !== activeDrop || $[3] !== extendedDrop || $[4] !== onDropContentClick || $[5] !== onQuote || $[6] !== onQuoteClick || $[7] !== onReply || $[8] !== onReplyClick) {
    t2 = <Drop drop={extendedDrop} previousDrop={null} nextDrop={null} showWaveInfo={true} showReplyAndQuote={true} activeDrop={activeDrop} location={DropLocation.MY_STREAM} dropViewDropId={null} onReply={onReply} onQuote={onQuote} onReplyClick={onReplyClick} onQuoteClick={onQuoteClick} onDropContentClick={onDropContentClick} />;
    $[2] = activeDrop;
    $[3] = extendedDrop;
    $[4] = onDropContentClick;
    $[5] = onQuote;
    $[6] = onQuoteClick;
    $[7] = onReply;
    $[8] = onReplyClick;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
}